import { CSSObject } from '@emotion/css';

export const textStyles: CSSObject = {
  '& h3': {
    color: 'var(--color-primary)',
  },
  '& h6': {
    paddingBottom: '1.5rem',
  },
  '& > *:last-child': {
    paddingBottom: 0,
  },
};
